import styled, { css } from 'styled-components'

import { Flex } from 'components/Box'
import Heading from 'components/Heading'
import CaptionBase from 'components/Caption'

import { ellipsis } from 'polished'
import { breakpoint } from 'utils'

export const Caption = styled(CaptionBase)`
  min-height: 20px;
`

export const SidebarContainer = styled.div.attrs({
  'data-testid': 'share-meta-sidebar',
})<{ isComponentsWebViewOn?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  flex: 1 0 auto;
  /* This is necessary for Safari to repaint after route transition */
  transform: translateZ(0);

  margin-top: ${({ isComponentsWebViewOn }) =>
    isComponentsWebViewOn ? `52px` : undefined};

  ${breakpoint('sm')`
    margin-top: 0;
  `};
`

export const SidebarSection = styled(Flex)<{
  borderTop?: boolean
  dark?: boolean
  innserSection?: boolean
  scroll?: boolean
}>`
  position: relative;
  flex-shrink: 0;

  &:first-child {
    padding-top: 20px;
  }

  &:last-child {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  /* border top to separate sections */
  ${({ borderTop }) =>
    borderTop &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.border.dark.base};
      & + & {
        border-top: none;
      }
    `}

  /* Section that has a border top that doesn't reach the whole width,
     usually used to create related sections */
  ${({ innserSection }) =>
    innserSection &&
    css`
      &:before {
        content: '';
        position: absolute;
        height: 1px;
        background: ${({ theme }) => theme.colors.border.dark.base};
        top: 0;
        right: 0;
        left: 16px;
      }
    `}

    /* Similar to innverSection but with border bottom */
    ${({ innserSectionBottom }) =>
    innserSectionBottom &&
    css`
      &:before {
        content: '';
        position: absolute;
        height: 1px;
        background: ${({ theme }) => theme.colors.border.dark.base};
        bottom: 0;
        right: 0;
        left: ${({ theme }) => theme.space[4]}px;
      }
    `}

  /* Section with scroll */
  ${({ scroll }) =>
    scroll &&
    css`
      flex-direction: column;
      flex: 0 1 auto;
      overflow-y: auto;
      height: 100%;
    `}
`

SidebarSection.defaultProps = {
  as: 'section',
  flexDirection: 'column',
  paddingTop: 4,
  paddingBottom: 4,
  paddingRight: 5,
  paddingLeft: 5,
}

export const SidebarSectionHeader = styled.header`
  display: flex;
  position: relative;
  margin-bottom: 16px;
`

export const SidebarHeaderContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`

export const SidebarHeading = styled(Heading.H2).attrs({
  'data-testid': 'share-meta-sidebar-title',
})`
  ${ellipsis('calc(100% - 1.5rem)')};
  margin: 0;
  display: block;
`
